import React from "react";
import { Marker } from "@react-google-maps/api";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

export default function CustomMarker(props: any) {
  const { position, clusterer } = props;

  return (
    <Marker
      aria-label="Activity location marker"
      position={position}
      clusterer={clusterer}
      icon={props.iconState}
      onClick={() => {
        props.removeOtherStyles();
        props.changeSize(props.index);
        position.ref.current.style.border = "5px solid " + PRIMARY_BUTTON_COLOR;
        position.ref.current.style.boxShadow =
          "rgba(0, 0, 0,1) 0px 0px 10px 0px";
        position.ref.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
        props.map.panTo(position);
      }}
    />
  );
}
